<app-layout>
  <div class="frequently-questions">
    <div class="frequently-questions__section">
      <div class="frequently-questions__header">
        <div class="frequently-questions__title">
          <p class="h1">Perguntas frequentes</p>
        </div>
        <div class="frequently-questions__subtitle">
          <p>Fique por dentro de tudo!</p>
        </div>
      </div>
    </div>

    <div class="frequently-questions__text">
      <div class="container">
        <h3>1. Onde posso comprar meus ingressos?</h3>

        <p>
          Você poderá efetuar sua compra pelo Site yes7tickets.net ou nos Pontos de Venda *OFICIAIS. *Atente-se às
          informações de cada Evento e não compre fora dos Canais de Vendas Oficiais para não correr o risco de ser
          lesado comprando ingressos falsificados.
        </p>

        <h3>2. Como posso imprimir meus tickets / ingressos?</h3>

        <p>
          Clique em "Área do Usuário", preencha seus dados cadastrais (login e senha), acesse "Compras Realizadas" e
          imprima os seus tickets / Ingresso Digital / Voucher.
        </p>

        <h3>3. Porque existe uma taxa de administração?</h3>

        <p>
          São valores pagos referentes aos serviços de conveniência dos ingressos individuais adquiridos através do
          nosso portal. Esta taxa compõe o valor cobrado pelas operadoras de cartão de crédito para realizar a
          transação, bem como a margem de lucratividade da Yes7 Tickets, pelo atendimento personalizado, praticidade e
          comodidade.
        </p>

        <h3>4. Como se fixam os preços dos ingressos?</h3>

        <p>Os preços dos ingressos são estabelecidos pelos produtores dos eventos.</p>

        <h3>5. Quantos ingressos podem ser comprados por CPF?</h3>

        <p>Tal número está sujeito à definição pelo Produtor de cada evento.</p>

        <h3>6. Como posso pagar meus ingressos?</h3>

        <p>
          Na plataforma LeveIngresso.com através de Cartões de Crédito, Pix e/ou Boleto. Nos Pontos de Vendas Oficiais
          de cada Evento é possível também comprar em Dinheiro.
        </p>

        <h3>7. Quais são as formas de entregas e os respectivos prazos?</h3>

        <p>E-ticket / Voucher / Ingresso Digital: é enviado por email minutos após a efetivação da compra;</p>

        <p>
          Baixe nosso Aplicativo: Yes7 Tickets (disponível nas Lojas de Aplicativos para Android e IOs) para acessar seu
          Voucher / Ingresso Digital e ficar por dentro das novidades também. Tenha o seu Voucher / Ingresso Digital na
          Palma da mão e ajude o Meio Ambiente.
        </p>

        <h3>8. Quais são os horários de atendimento?</h3>

        <p>
          Nosso atendimento é feito através do e-mail: contato&#64;yes7tickets.net ou através da página de Contato. Só
          nos enviar o email com sua dúvida que responderemos o mais breve possível.
        </p>

        <h3>9. O que é o código de segurança do meu cartão de crédito?</h3>

        <p>
          O código de segurança do cartão de crédito é uma sequência numérica complementar ao número do cartão,
          garantindo a veracidade dos dados da transação eletrônica, uma vez que essa informação é verificada somente
          pelo portador do cartão e não consta em nenhum tipo de leitura magnética. Ele se encontra no verso do cartão e
          corresponde aos três últimos dígitos da faixa numérica.
        </p>

        <h3>10. O que é o prazo de validade do meu cartão de crédito?</h3>

        <p>
          O prazo de validade do cartão de crédito é data de expiração, geralmente localizado na parte frontal/ou verso
          deste, acima do nome do titular do cartão.
        </p>

        <h3>11. Como comprar ingressos de Meia Entrada ("Meia Estudante")?</h3>

        <p>
          A Meia Entrada é regida pela Lei Federal nº 12.933/2013. Se você se enquadra dentro dos termos para Meia
          Entrada, é só se cadastrar em nossa plataforma ou ir em um Ponto de Venda Oficial do Evento, escolher o
          Ingresso para MEIA ENTRADA e comprovar o seu Direito à Meia Entrada na Portaria do Evento. Deve-se verificar a
          disponibilidade deste, o que depende do tipo de cada evento.
        </p>

        <h3>12. Posso cancelar minha compra?</h3>

        <p>
          De acordo com o Código de Defesa do Consumidor (Artigo 49), em caso de desistência da compra, que deverá
          ocorrer em, no máximo, até 7 (sete) dias corridos após a compra e que esteja dentro do prazo de até 24 (vinte
          e quatro) horas antes do início do evento.
        </p>
        <p>
          Para verificar a viabilidade do cancelamento do(s) seu(s) ingresso(s) você deve entrar em contato atráves do
          email: atendimento&#64;leveingresso.com, informar o motivo do mesmo e aguardar sua resposta via email.
          Responderemos o mais breve possível.
        </p>
        <p>*O valor referente a Taxa de Conveniência não será devolvido.</p>

        <h3>13. Como posso saber antecipadamente dos eventos?</h3>

        <p>
          Se cadastrando em nosso site yes7tickets.net. Desta forma, você receberá, semanalmente, informações com os
          novos eventos
        </p>

        <h3>14. Fiz a compra mas não recebi a confirmação, o que fazer?</h3>

        <p>
          As solicitações de compra passam por um processo de aprovação junto à administradora de cartões de crédito,
          pix ou boleto. É normal que demorem alguns minutos para que a transação possa ser aprovada junto à Operadora
          de Cartão. Sendo assim, aguarde alguns minutos após concluir sua compra.
        </p>
        <p>
          Caso você não receba o e-mail confirmando o pagamento, acesse o site da Yes7 Tickets, clique em "Área do
          Usuário", informe seus dados de login e senha e, no campo "Compras Realizadas", verifique se o pagamento foi
          realizado/aprovado com sucesso. Se foi, aparecerá em seu pedido o status "Válido". Caso deseje imprimí-lo,
          basta clicar sob o ícone imprimir o seu Voucher / Ingresso.
        </p>
        <p>
          Para a sua Melhor Experiência, Baixe nosso Aplicativo: Yes7 Tickets, que está disponível nas Lojas de
          Aplicativos para Android e IOs e, além de ter o seu Voucher / Ingresso Digital na Palma da mão, ajudar o Meio
          Ambiente ainda poderá receber as notificações dos Eventos.
        </p>
        <p>
          Para maiores informações ou dúvidas, envie email para: contato&#64;yes7tickets.net, informe a sua dúvida que
          responderemos o mais breve possível.
        </p>
      </div>
    </div>
  </div>
</app-layout>
